import { Megaphone, ChevronRight } from "lucide-react";
import { SmartLink } from "../SmartLink";
import { CoinBadge } from "../CoinBadge";
import { IMG, resolveImg } from "./images";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { day: "2-digit", month: "2-digit", year: "numeric" }) : "");

export const AzNews = ({ news }) => {
  if (!news.length) return null;
  const items = [...news, ...news];
  return (
    <section className="az-wrap az-news" data-testid="az-news">
      <span className="az-news-label"><Megaphone size={16} /> Latest news</span>
      <div className="az-news-track">
        <div className="az-news-run" style={{ animationDuration: `${Math.max(news.length * 7, 20)}s` }}>
          {items.map((n, i) => (
            <SmartLink key={`${n.id}-${i}`} href={n.link || "/blogs"} className="az-news-item" data-testid={`az-news-item-${i}`}>
              <em>{fmtDate(n.date)}</em> {n.title}
            </SmartLink>
          ))}
        </div>
      </div>
      <SmartLink href="/blogs" className="az-news-more" data-testid="az-news-more">More <ChevronRight size={14} /></SmartLink>
    </section>
  );
};

export const AzListings = ({ listings }) => {
  if (!listings.length) return null;
  return (
    <section className="az-wrap az-listings" data-testid="az-listings">
      {listings.map((l) => (
        <SmartLink key={l.symbol} href={`/trade?symbol=${l.symbol}_USDT`} className="az-listing" style={{ backgroundImage: `url(${resolveImg(l.card_image) || IMG.listingBg})` }} data-testid={`az-listing-${l.symbol}`}>
          <small>New listing</small>
          <b>{l.name}</b>
          <span className="az-listing-sym"><CoinBadge logo={l.logo} symbol={l.symbol} size={26} /> {l.symbol}/USDT</span>
          <em>{fmtDate(l.date)}</em>
        </SmartLink>
      ))}
    </section>
  );
};
